import styled from 'styled-components';

import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.buyBar.SwiperSlides';

interface IOutOfStockProps {
  isActive?: boolean;
  isCurrentlyUnavailable?: boolean;
}

export const OutOfStock = ({
  isActive = false,
  isCurrentlyUnavailable = false,
}: IOutOfStockProps) => {
  const renderText = () => {
    if (isCurrentlyUnavailable) {
      return t(`${TP}.currentlyUnavailable`, 'Currently Unavailable');
    }
    if (isActive) {
      return t(`${TP}.makeOffer`, 'Make Offer');
    }
    return t(`${TP}.offer`, 'Offer');
  };

  return <OutOfStock.Root data-qa="buy_bar_oos">{renderText()}</OutOfStock.Root>;
};

OutOfStock.Root = styled.div`
  &:hover {
    text-decoration: underline;
  }
`;
